namespace TabAurous.Production {
    export interface DismantlingReturnItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        CalcUnitId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        HasBom: Serenity.BooleanEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.IntegerEditor;
        UnitCost: Serenity.DecimalEditor;
        DiscountPer: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        DepartmentId: Serenity.IntegerEditor;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        CostMethodId: Serenity.EnumEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
    }

    export class DismantlingReturnItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.DismantlingReturnItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DismantlingReturnItemsForm.init)  {
                DismantlingReturnItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = StoneSieveLookup;
                var w5 = WeightEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.BooleanEditor;
                var w8 = s.DateEditor;
                var w9 = s.EnumEditor;
                var w10 = s.ImageUploadEditor;

                Q.initFormType(DismantlingReturnItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'BagNo', w0,
                    'SKU', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'AttributeId', w0,
                    'ProductTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w2,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'MetalId', w2,
                    'Attribute', w0,
                    'CalcUnitId', w2,
                    'KaratId', w2,
                    'MetalColorId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w4,
                    'GroupSieveId', w4,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'Pieces', w1,
                    'Weight', w5,
                    'UnitRate', w6,
                    'UnitLabour', w6,
                    'NetAmount', w6,
                    'GrossAmount', w6,
                    'Line_No', w0,
                    'HSN', w2,
                    'TaxCode', w2,
                    'HasBom', w7,
                    'NetWeight', w5,
                    'DiamondPieces', w1,
                    'DiamondWeight', w5,
                    'StonePieces', w1,
                    'StoneWeight', w5,
                    'OtherPieces', w1,
                    'OtherWeight', w5,
                    'MetalAmount', w6,
                    'DiamondAmount', w6,
                    'StoneAmount', w6,
                    'OtherAmount', w6,
                    'CalcOnId', w1,
                    'UnitCost', w6,
                    'DiscountPer', w6,
                    'Discount', w6,
                    'WstPer', w6,
                    'WstWt', w5,
                    'Purity', w6,
                    'PureWeight', w5,
                    'DepartmentId', w1,
                    'Remarks', w0,
                    'IsDisabled', w7,
                    'ServerDate', w8,
                    'CostMethodId', w9,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w8,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'ImageName', w10
                ]);
            }
        }
    }
}
